import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FilterChipsComponent } from './filter-chips/filter-chips.component';
import { HorizontalListComponent } from './horizontal-list/horizontal-list.component';
import { MiradorItemComponent } from './mirador-item/mirador-item.component';
import { ShellModule } from './shell/shell.module'
import { ExperienceCardComponent } from './experience-card/experience-card.component';
import { SharedModule } from '../shared.module';
import { MiradorMapCardComponent } from './mirador-map-card/mirador-map-card.component';
import { ExperienceMapCardComponent } from './experience-map-card/experience-map-card.component';
import { FilterChipsAlbumComponent } from './filter-chips-album/filter-chips-album.component';
import { PipesModule } from '../pipes/pipes.module';
import { HorizontalListAlbumComponent } from './horizontal-list-album/horizontal-list-album.component';
import { MiradorMapCardAlbumComponent } from './mirador-map-card-album/mirador-map-card-album.component';
import { HorizontalListExperiencesComponent } from './horizontal-list-experiences/horizontal-list-experiences.component';
import { AlbumCardComponent } from './album-card/album-card.component';
import { EventCardComponent } from './event-card/event-card.component';
import { ExperienceRecordVisitPage } from './experiences/experience-record-visit/experience-record-visit.page';
import { ExperienceReviewPage } from './experiences/experience-review/experience-review.page';
import { ExperienceReviewListPage } from './experiences/experience-review-list/experience-review-list.page';
import { HorizontalListSitesComponent } from './horizontal-list-sites/horizontal-list-sites.component';

const routes: Routes = [
  {
    path: 'ghgh',
    loadChildren: () => import('../pages/list-detail/list-detail.module').then( m => m.ListDetailPageModule)
  }
];

@NgModule({
  declarations: [
    HorizontalListSitesComponent,
    HorizontalListComponent,
    HorizontalListAlbumComponent,
    HorizontalListExperiencesComponent,
    MiradorItemComponent,
    FilterChipsComponent,
    FilterChipsAlbumComponent,
    MiradorMapCardComponent,
    MiradorMapCardAlbumComponent,
    ExperienceMapCardComponent,
    AlbumCardComponent,
    ExperienceRecordVisitPage,
    ExperienceReviewPage,
    ExperienceReviewListPage

  ],
  imports: [
    RouterModule.forChild(routes),
    ShellModule,
    SharedModule,
    PipesModule
  ],
  exports: [
    HorizontalListSitesComponent,
    HorizontalListComponent,
    HorizontalListAlbumComponent,
    HorizontalListExperiencesComponent,
    MiradorItemComponent,
    FilterChipsComponent,
    FilterChipsAlbumComponent,
    MiradorMapCardComponent,
    MiradorMapCardAlbumComponent,
    ExperienceMapCardComponent,
    AlbumCardComponent,
    ExperienceRecordVisitPage,
    ExperienceReviewPage,
    ExperienceReviewListPage
  ]
})
export class AppShareComponentsModule {}
